import { createContext } from "react";
const HashTagContext = createContext({});

export default HashTagContext;
